import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';
import { responseLogWithNotification } from '../../../utils/utils';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { addGlobalPopUpWrapper, clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import {
  dateTimeFormatter,
  infoFormatterIntl,
  localeFormatter,
  vehicleRegisterStatusFormatter,
} from '../../../utils/formatters';
import { loadVehicleRegistryById } from '../../VehicleRegistry/actions';
import { getVehicleRegistryData } from '../../VehicleRegistry/reducer';
import { AccordionDetails } from '../../../components/base/Accordion/AccordionDetails';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function VehicleRegistryPopUp(props) {
  const { id } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentVehicleRegistry = {},
    loadingCurrentVehicleRegistry,
  } = useSelector(getVehicleRegistryData);

  useEffect(() => {
    dispatch(loadVehicleRegistryById(id)).catch(responseLogWithNotification);
  }, [id]);

  const carrier = Array.isArray(currentVehicleRegistry?.carrier_vehicles) && currentVehicleRegistry?.carrier_vehicles?.length ? currentVehicleRegistry?.carrier_vehicles[0]?.carrier : {};
  const vehicle = currentVehicleRegistry?.registry_vehicle;

  return (
    <div className={classNames('full-view custom-scroll-theme vehicle-registry-popup')}>
      <TimerLoader loading={loadingCurrentVehicleRegistry} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'vehicle.register.details' }, { lpn: currentVehicleRegistry?.vehicle_lpn })}</div>
        <Icons
          onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.VEHICLE_REGISTRY_POP_UP })))}
          customIcon
          icon="close"
        />
      </div>
      <div className="full-view-content">
        <div className="view-content-wrapper">
          <div className="info-row mt-1">
            <div className="f4">Текущий статус</div>
            <div className="info-block d-flex flex-row">
              <div>{vehicleRegisterStatusFormatter(currentVehicleRegistry?.vehicle_status)}</div>
              {/* <div className="ms-auto"> */}
              {/*  <div */}
              {/*    className="details-button" */}
              {/*    onClick={() => { */}
              {/*      dispatch((addGlobalPopUpWrapper({ */}
              {/*        window2: POPUP_LIST_NAME.VEHICLE_REGISTRY_STATUS_HISTORY_POP_UP, */}
              {/*        id: currentVehicleRegistry?.applicant?.id, */}
              {/*      }))); */}
              {/*    }} */}
              {/*  >История */}
              {/*  </div> */}
              {/* </div> */}
            </div>
          </div>
          <AccordionDetails
            content={(
              <>
                <Row className="row-cols-2">
                  {infoFormatterIntl('last_name', currentVehicleRegistry?.driver?.driver_last_name, {}, 'last_name')}
                  {infoFormatterIntl('first_name', currentVehicleRegistry?.driver?.driver_first_name, {}, 'first_name')}
                </Row>
                <Row className="row-cols-2">
                  {infoFormatterIntl('middle_name', currentVehicleRegistry?.driver?.driver_middle_name, {}, 'middle_name')}
                  {infoFormatterIntl('vehicle.external_id', currentVehicleRegistry?.driver?.driver_external_id, {}, 'external_id')}
                </Row>
              </>
            )}
            toggleFunction={() => dispatch((addGlobalPopUpWrapper({
              window2: POPUP_LIST_NAME.DRIVER_POP_UP,
              id2: currentVehicleRegistry?.driver_id,
            })))}
            title="Водитель"
          />
          {/* <div className="info-row mt-1"> */}
          {/*  <div className="f4">Дата и время события</div> */}
          {/*  <div className="info-container">{dateTimeFormatter(currentVehicleRegistry?.created_at)}</div> */}
          {/* </div> */}
          <div className="info-row mt-1">
            <div className="f4">Последнее обновление</div>
            <div className="info-container">{dateTimeFormatter(currentVehicleRegistry?.updated_at)}</div>
          </div>
          {/* <div className="info-row mt-1"> */}
          {/*  <div className="f4">Данные реестра ЛТ</div> */}
          {/*  <div className="info-container">{inRegistryFormatter(!!currentVehicleRegistry?.registry_vehicle?.number || currentVehicleRegistry?.registry_number)}</div> */}
          {/* </div> */}
          <div className="info-row mt-1">
            <div className="f4">Номер записи в реестре ЛТ</div>
            <div className="info-block d-flex flex-row info-container">
              { vehicle?.id ? <NavLink target="_blank" to={`/region-registry/passenger-taxi?registry_id=${vehicle?.id}`}>{vehicle?.number}</NavLink> : (
                <div className="in-registry">
                  <Icons customIcon icon="red-close" /> Нет
                </div>
              ) }
            </div>
          </div>
          <div className="info-row mt-1">
            <div className="f4">Номер записи в реестре перевозчиков</div>
            <div className="info-block info-container">
              { carrier?.id ? <NavLink target="_blank" to={`/region-registry-carrier?registry_id=${carrier?.id}`}>{carrier?.number}</NavLink> : (
                <div className="in-registry">
                  <Icons customIcon icon="red-close" /> Нет
                </div>
              )}
            </div>
          </div>
          <div className="info-row mt-1">
            <div className="f4">Наименование перевозчика</div>
            <div className="info-container">{currentVehicleRegistry?.carrier_name}</div>
          </div>
          <div className="info-row mt-1">
            <div className="f4">Последние координаты</div>
          </div>
          <Row className="row-cols-2">
            {infoFormatterIntl('latitude', currentVehicleRegistry?.last_latitude, {}, 'latitude')}
            {infoFormatterIntl('longitude', currentVehicleRegistry?.last_longitude, {}, 'longitude')}
          </Row>
          <div className="info-row mt-1">
            <div className="f4">Скорость, км/ч</div>
            <div className="info-container">{currentVehicleRegistry?.last_speed}</div>
          </div>
          <div className="info-row mt-1">
            <div className="f4">Общее время в пути</div>
            <div className="info-container">{currentVehicleRegistry?.total_travel_time}</div>
          </div>
          <AccordionDetails
            content={(
              <>
                <Row className="row-cols-2">
                  {infoFormatterIntl('vehicle_brand', currentVehicleRegistry?.vehicle_brand, {}, 'vehicle_brand')}
                  {infoFormatterIntl('vehicle_model', currentVehicleRegistry?.vehicle_model, {}, 'vehicle_model')}
                </Row>
                <Row className="row-cols-2">
                  {infoFormatterIntl('vehicle_color', currentVehicleRegistry?.vehicle_color, {}, 'inn')}
                  {infoFormatterIntl('grn_ts', currentVehicleRegistry?.vehicle_lpn, {}, 'ogrn')}
                </Row>
                <Row className="row-cols-2">
                  {infoFormatterIntl('vehicle_vin', currentVehicleRegistry?.vehicle_vin, {}, 'vehicle_vin')}
                  {infoFormatterIntl('ecology_class', localeFormatter('ecology-class', currentVehicleRegistry?.registry_vehicle?.ecology_class), {}, 'ecology_class')}
                </Row>
                <Row className="row-cols-2">
                  {infoFormatterIntl('is_illegal', currentVehicleRegistry?.is_illegal ? 'Нелегально' : 'Легально', {}, 'is_illegal')}
                  {infoFormatterIntl('illegal_reasons', (currentVehicleRegistry?.illegal_reasons?.length ? currentVehicleRegistry?.illegal_reasons : [])?.map(item => item?.message).join(','), {}, 'first_name')}
                </Row>
              </>
            )}
            toggleFunction={() => dispatch((addGlobalPopUpWrapper({
              window2: POPUP_LIST_NAME.TRANSPORT_DETAIL,
              id2: currentVehicleRegistry?.id,
            })))}
            title="Транспортное средство"
          />
          <div className="info-row mt-1">
            <div className="f4">История поездок</div>
            <div className="info-block d-flex flex-row info-container">
              <div />
              <div className="ms-auto">
                <NavLink className="details-button" target="_blank" to={`/vehicle-registry/travel-history?vehicle_id=${currentVehicleRegistry?.id}&vehicle_lpn=${currentVehicleRegistry?.vehicle_lpn}`}>Перейти</NavLink>
              </div>
            </div>
          </div>
          <div className="info-row mt-1">
            <div className="f4">Путевой лист</div>
            <div className="info-block d-flex flex-row info-container">
              <div />
              <div className="ms-auto">
                <div
                  className="details-button"
                  onClick={() => {
                    dispatch((addGlobalPopUpWrapper({
                      window2: POPUP_LIST_NAME.WAY_BILL_DETAIL,
                      id2: currentVehicleRegistry?.driver_id,
                    })));
                  }}
                >Подробнее
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
